import { Checkbox } from "components/Atoms/inputs/Checkbox";
import React from "react";

interface Props {
  selectedMergeFieldsSet: Set<string>
  subtopic: server.dto.AvailableMergeFieldSubTopic
  onMergefieldChanged: (mergefield: string, checked: boolean) => void
}

const MergeSubTopic = (props: Props) => {
  if (props.subtopic.mergeFields.length === 0) {
    return null;
  }

  return <div className="merge-sub-topic-wrapper">
    <h3>{props.subtopic.label}</h3>

    <div className="merge-sub-topic-grid">
      {props.subtopic.mergeFields.map(mf => (
        <React.Fragment key={mf.mergeField}>
          <Checkbox
            label={mf.label}
            checked={props.selectedMergeFieldsSet.has(mf.mergeField)}
            onChange={(_, checked) => {
              props.onMergefieldChanged(mf.mergeField, checked);
            }}
          />
          <div>
            {mf.mergeField}
          </div>
        </React.Fragment>
      ))}
    </div>
  </div>;
};

export default MergeSubTopic;